Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e = require("react"),
  t = require("react-spring");
function n(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}
var r = n(e),
  _o = function o() {
    return _o = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }
      return e;
    }, _o.apply(this, arguments);
  },
  a = {
    x: 0,
    y: 0
  },
  u = {
    x: new t.SpringValue(0),
    y: new t.SpringValue(0)
  },
  i = e.createContext(u),
  l = function l() {
    return e.useContext(i);
  };
exports.MouseParallaxChild = function (n) {
  var a = n.factorX,
    u = void 0 === a ? 1 : a,
    i = n.factorY,
    c = void 0 === i ? 1 : i,
    s = n.inverted,
    d = void 0 !== s && s,
    f = n.className,
    v = n.style,
    p = n.children,
    m = l(),
    x = e.useCallback(function (e) {
      return {
        x: e.x.to(function (e) {
          return e * u * (d ? -1 : 1);
        }),
        y: e.y.to(function (e) {
          return e * c * (d ? -1 : 1);
        })
      };
    }, [u, c]),
    y = _o(_o({}, x(m)), v);
  return r.default.createElement(r.default.Fragment, null, r.default.createElement(t.animated.div, _o({}, {
    className: f
  }, {
    style: y
  }), p));
}, exports.MouseParallaxContainer = function (n) {
  var u = n.globalFactorX,
    l = void 0 === u ? 1 : u,
    c = n.globalFactorY,
    s = void 0 === c ? 1 : c,
    d = n.resetOnLeave,
    f = n.useWindowMouseEvents,
    v = n.inverted,
    p = n.springConfig,
    m = n.enabled,
    x = void 0 === m || m,
    y = n.containerStyle,
    g = n.className,
    w = n.children,
    b = t.useSpring(function () {
      return _o(_o({}, a), p ? {
        config: p
      } : {});
    }),
    C = b[0],
    E = b[1],
    h = function h() {
      return E.start(a);
    },
    M = e.useState({
      current: null
    }),
    L = M[0],
    O = M[1],
    P = e.useCallback(function (e) {
      null !== e && O({
        current: e
      });
    }, []),
    S = e.useCallback(function (e) {
      var t = L.current ? L.current.getBoundingClientRect() : {
        left: 0,
        top: 0
      };
      return {
        x: e.clientX - t.left,
        y: e.clientY - t.top
      };
    }, [L]),
    j = e.useCallback(function (e) {
      if (L.current) {
        var t = L.current.clientHeight,
          n = L.current.clientWidth,
          r = S(e),
          o = {
            x: (n / 2 - r.x) * l * (v ? -1 : 1),
            y: (t / 2 - r.y) * s * (v ? -1 : 1)
          };
        E.start(o);
      }
    }, [L, S, v]);
  e.useEffect(function () {
    return x && f && L.current && (window.addEventListener("mousemove", j, !1), d && window.addEventListener("mouseout", h, !1)), function () {
      x && f && L.current && (window.removeEventListener("mousemove", j, !1), d && window.removeEventListener("mouseout", h, !1));
    };
  }, [L, j, d, f, x]);
  var k = {
    onMouseMove: x && !f ? j : void 0,
    onMouseLeave: x && !f && d ? h : void 0
  };
  return r.default.createElement(i.Provider, {
    value: C
  }, r.default.createElement("div", _o({
    id: "mouse-parallax-container",
    ref: P,
    style: _o({
      overflow: "hidden",
      position: "relative"
    }, y)
  }, {
    className: g
  }, k), w));
}, exports.useParallaxOffset = l;